import { render, staticRenderFns } from "./West1School.vue?vue&type=template&id=45b7370b&"
import script from "./West1School.vue?vue&type=script&lang=js&"
export * from "./West1School.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports